/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */


var Model = require("../types/Model.js");

module.exports = Model({
	name: "managedsectionupdates",
	init: init,
	uninit: uninit,
	listeners: listeners,

	_who_tracker: null,
	_who: null,

	refresh: refresh,
	reset: reset,
});

function init(){
	this._who_tracker = this.dispatcher.createTracker();
	this.reset();
}

function uninit() {
	this._manageGroup = null;
	this._who = null;
	this._who_tracker.off();
	this._who_tracker = null;
}

function listeners() {
	return {
		"managedaccount:updated": track,
		"connectivity:online": refresh
	};
}

function track(managedaccount) {
	if(!managedaccount.open)
		return this.reset();

	var who = managedaccount.data._id;

	if(who === this._who) return;

	this.reset();

	this._who = who;

	var group = managedaccount.group;
	this._group = group;

	if(group){
		this._who_tracker.on("mqtt:managegroup/" + group + "/patient/u/" + who + "/updates/change", handle_change.bind(this));
	} else {
		this._who_tracker.on("mqtt:u/" + who + "/updates/change", handle_change.bind(this));
	}

	this.refresh();
}

function handle_change(data) {
	var section = data.section;
	var timestamp = data.timestamp;
	var update = {};
	update[section] = timestamp;
	this.extend(update);
}

function refresh() {
	var who = this._who;
	var group = this._group;
	if(!who) return;
	this.emit("save:trigger:start");
	return this.api.manage.updates
		.list(who, group)
		.then(this.push.bind(this))
		.catch(console.error.bind(console))
		.then(finish_save.bind(this));
}

function finish_save() {
	this.emit("save:trigger:finish");
}

function reset() {
	this._who = null;
	this._who_tracker.off();
	this.push({});
}
